import { __decorate } from "tslib";
import Component from "vue-class-component";
import Task from "@/services/task";
import ReactiveComponent from "@/components/ReactiveComponent";
import TemplateContent from "@/components/template/TemplateContent.vue";
let VideosList = class VideosList extends ReactiveComponent {
    constructor() {
        super(...arguments);
        this.tdClass = "videos-datatable";
        this.fields = [
            {
                key: "name_normalized",
                label: "Name",
                sortable: true,
                tdClass: this.tdClass
            },
            {
                key: "link",
                label: "Link",
                sortable: false,
                tdClass: this.tdClass
            },
            { key: "actions", label: "Actions", sortable: false, tdClass: this.tdClass }
        ];
        this.videosQuery = { videos: [] };
        this.videosTask = Task.idle();
        this.updateStatusTask = Task.idle();
        this.deleteTask = Task.idle();
    }
    created() {
        this.subscribeQuery({
            tag: "videos",
            options: {
                query: require("@/apollo/queries/videosList.graphql")
            },
            onTask: task => {
                this.videosTask = task;
                if (task.isSuccessful) {
                    this.videosQuery = task.data;
                }
            }
        });
    }
    get videos() {
        return this.videosQuery.videos;
    }
    async deleteVideo(videoId) {
        const video = this.videos.find(it => it.id === videoId);
        if (video == undefined) {
            return;
        }
        const result = await this.$bvModal.msgBoxConfirm(`Delete ${video.name}?\nThis action is definitive`, {
            size: "sm",
            buttonSize: "md",
            okVariant: "danger",
            okTitle: "Delete",
            cancelTitle: "Cancel",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true
        });
        if (result !== true) {
            return;
        }
        const videosQuery = require("@/apollo/queries/videosList.graphql");
        this.subscribeMutation({
            tag: "deleteVideo",
            options: {
                mutation: require("@/apollo/mutations/deleteVideo.graphql"),
                variables: {
                    id: video.id
                },
                update: (store, { data }) => {
                    try {
                        const videosQueryCache = store.readQuery({
                            query: videosQuery
                        });
                        if (data.delete_videos.affected_rows != 1) {
                            return;
                        }
                        const index = videosQueryCache.videos.findIndex(it => it.id == video.id);
                        if (index < 0) {
                            return;
                        }
                        videosQueryCache.videos.splice(index, 1);
                        store.writeQuery({ query: videosQuery, data: videosQueryCache });
                    }
                    catch (e) {
                        console.log("Failed to update cache after delete_user mutation");
                    }
                },
                optimisticResponse: {
                    __typename: "mutation_root",
                    delete_videos: {
                        __typename: "videos_mutation_response",
                        affected_rows: 1
                    }
                }
            },
            onTask: task => (this.deleteTask = task)
        });
    }
};
VideosList = __decorate([
    Component({
        components: { TemplateContent }
    })
], VideosList);
export default VideosList;
